<template>
  <div class="wrap_login">
    <mt-header fixed title="登录" class="yp-topbar"></mt-header>
    <logo></logo>
    <div>
      <form class="loginForm" id="loginForm" onsubmit="return false">
        <div class="errowShow" v-if="isShow">{{tishi}}</div>
        <div class="form-group">
          <label class="login_label" v-show="!isOnly">法院</label>
          <input type="text" placeholder="请选择" class="address inputForm" v-model="address"
                 style="width: 68%" readonly="readonly" @click="modal1()">
          <i class="iconfont icon-right"
             style="position: absolute;right: .3rem;font-weight: bolder;color: #C7C7CC;" @click="modal()"></i>
        </div>
        <div class="form-group">
          <label class="login_label">帐号</label>
          <input for="username" type="text" placeholder="请输入帐号" class="account inputForm" v-model="account"
                 v-on:blur="changeAccount"
                 v-on:focus="focusAccount">
        </div>
        <div class="form-group" style="display: none">
          <input type="text">
        </div>
        <div class="form-group">
          <label class="login_label">密码</label>
          <input type="hidden" style="display: none">
          <input for="password" :type="types" placeholder="请输入密码" class="password inputForm" v-model="password"
                 maxlength="16">
          <!--<span class="iconfont icon-yiyun togglePsd" @click="togglePsd"></span>-->
          <img :src="changePsd" class="togglePsd" style="top: 0.25rem; width: 0.4rem;height: 0.4rem;"
               @click="togglePsd"/>
          <input type="hidden" style="display: none">
        </div>
        <div class="form-group">
          <label class="login_label">验证码</label>
          <input type="text" placeholder="请输入验证码" class="checkCode inputForm" maxlength="6"
                 v-model="checkCode">
          <img id="imgcontainer" @click="getCode" :src="codeUrl" ref="imgBox"/>
        </div>
        <div style="padding: 0.4rem 0.4rem 0">
          <mt-button type="primary" size="large" class="btn" @click="toLogin">登录</mt-button>
        </div>
      </form>
    </div>
    <!--注册找回密码-->
    <!--<div class="link">-->
    <!--<router-link to="/account/register" class="fl">立即注册</router-link>-->
    <!--<router-link to="/account/forget" class="fr">忘记密码</router-link>-->
    <!--</div>-->
    <!--法院选择-->
    <div class="model" v-show="sheetVisible">
      <!--<mt-picker :slots="slots" @change="onValuesChange1" class="picker"-->
      <!--@click="picker" v-show="one"></mt-picker>-->
      <!--<mt-picker :slots="slots" @change="onValuesChange2" class="picker"-->
      <!--@click="picker" v-show="two"></mt-picker>-->
      <!--<mt-picker :slots="slots" @change="onValuesChange3" class="picker"-->
      <!--@click="picker" v-show="three"></mt-picker>-->
      <div class="modelTop">
        <div>
          <span class="modelBtn fl" @click="cancel()">取消</span>
          <span class="modelBtn fr" @click="sure()">确定</span>
        </div>
      </div>
      <div class="ulList">
        <ul class="addressList" v-show="one">
          <li v-for="(item,index) in list1">
            <div style="padding: 0 .3rem">
              <span class="check" :class="{'checked': item.ischecked, 'nochecked': !item.ischecked}"
                    @click="checked(item)"></span>
              <span @click="nextTown(item)" :children="stringfy(item.children)"
                    :class="{'fontColor': item.isColor,'nofontColor': !item.isColor}">{{item.tenantName}}</span>
            </div>
          </li>
        </ul>
        <ul class="addressList" v-show="two">
          <li v-for="(item,index) in list2">
            <div style="padding: 0 .3rem">
              <span class="check" :class="{'checked': item.ischecked, 'nochecked': !item.ischecked}"
                    @click="checked(item)"></span>
              <span @click="nextTown1(item)" :children="stringfy(item.children)"
                    :class="{'fontColor': item.isColor,'nofontColor': !item.isColor}">{{item.tenantName}}</span>
            </div>
          </li>
        </ul>
        <ul class="addressList" v-show="three">
          <li v-for="(item,index) in list3">
            <div style="padding: 0 .3rem">
              <span class="check" :class="{'checked': item.ischecked, 'nochecked': !item.ischecked}"
                    @click="checked(item,index)"></span>
              <span @click="nextTown2(item)" :children="stringfy(item.children)"
                    :class="{'fontColor': item.isColor,'nofontColor': !item.isColor}">{{item.tenantName}}</span>
            </div>
          </li>
        </ul>
      </div>

    </div>
    <div class="v-model" v-if="sheetVisible"
         @click="sheetVisible=false;"></div>
  </div>
</template>
<script type="text/ecmascript-6">
  import apis from '../../apis/index'
  import cloudApi from '../../apis/cloudStorageApi'
  import logo from '../../common/logo'
  import { MessageBox } from 'mint-ui'
  import { GetQueryString } from '@/assets/js/tools'
  import crypto from '@/utils/crypto'

  let checking = null
  export default {
    name: 'Login',
    data () {
      return {
        changePsd: require('../../assets/images/changePsd.png'),
        types: 'password',
        codeUrl: '',
        account: '',
        password: '',
        isShow: false,
        tishi: '',
        checkCode: '',
        address: '',
        sheetVisible: false,
        ischecked: false,
        isColor: false,
        pid: '',
        maxLen: 5,
        districtCode: '',
        list1: [],
        list2: [],
        list3: [],
        tenant: '',
        one: true,
        two: false,
        three: false,
        value1: '',
        value2: '',
        value3: '',
        isOnly: ''
      }
    },
    created: function () {
      this.cityAdress()
      this.address = localStorage.addressDataValue
      var ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('yicbridge') !== -1) {
        this.singlePointLogin()
      }
    },
    mounted: function () {
      this.getCode()
      // this.testPlatform()
    },
    components: {
      logo
    },
    methods: {
      singlePointLogin () {
        // let a = navigator.userAgent.toLowerCase() === 'yicbridge' && window.yicbridge.getSign()
        // let sign = a || GetQueryString('sign')
        let sign = GetQueryString('sign')
        let _this = this
        apis.request(cloudApi.login2, { sign: sign }).then(response => {
          if (response.data === 'true') {
            apis.request(cloudApi.record, { channel: '3' }, function () {
            })
            apis.request(cloudApi.show).then(function (res) {
              window.sessionStorage.mobileData = JSON.stringify(res.data)
              _this.$router.push({ path: '/index' })
              // _this.$store.dispatch('getPermissionBtns').then(() => {
              // })
            })
          }
        })
      },
      testPlatform () {
        let agent = navigator.userAgent.toLowerCase()
        let android = agent.indexOf('android')
        if (android !== -1) {
          MessageBox({
            title: '',
            message: '为保证正常操作，安卓用户请下载【法务云盘】app使用',
            showCancelButton: false
          })
        }
      },
      togglePsd () {
        this.types = this.types === 'text' ? 'password' : 'text'
        this.changePsd = this.types === 'text' ? require('../../assets/images/changePsd1.png') : require('../../assets/images/changePsd.png')
      },
      changeAccount: function () {
        this.isShow = false
      },
      focusAccount: function () {
        this.isShow = false
      },
      toLogin () {
        if (this.address === '') {
          this.isShow = true
          this.tishi = '请选择法院'
        } else if (this.account === '' || this.password === '') {
          this.isShow = true
          this.tishi = '帐号或密码不能为空'
        } else if (this.account.trim().length === 0) {
          this.isShow = true
          this.tishi = '帐号不能为空'
        } else if (this.password.trim().length === 0) {
          this.isShow = true
          this.tishi = '密码不能为空'
        } else if (this.checkCode === '') {
          this.isShow = true
          this.tishi = '验证码不能为空'
        }
        this.changCode()
      },
      getCode () {
        this.checkCode = ''
        apis.request(cloudApi.getCode).then((res) => {
          this.codeUrl = 'data:image/gif;base64,' + res.data.base64Str
        })
      },
      changCode () {
        var self = this
        var code = self.checkCode.trim()
        if (code.length === 0 || code.length > 6 || code.length < 6) {
          return
        }
        if (code.length === 6) {
          apis.request(cloudApi.checkCode, { code: code }).then(function (response) {
            let data = response.data
            if (data === false) {
              code = ''
              self.getCode()
              self.isShow = true
              self.tishi = '验证码错误'
            } else {
              self.isShow = false
              self.submitForm(true)
            }
          })
        }
      },
      submitForm () {
        var self = this
        let data = { 'username': self.account, 'password': crypto.Encrypt(self.password), 'code': self.checkCode, 'rememberMe': 'on' }
        apis.request(cloudApi.login, data, { 'tenant': localStorage.addressData }).then(function (res) {
          apis.request(cloudApi.record, { channel: '3' }, function () {
          })
          apis.request(cloudApi.show).then(function (res) {
            if (res.data.needResetPassword) {
              self.$router.push({ path: '/modifyPassword', query: { account: self.account } })
            } else {
              window.sessionStorage.mobileData = JSON.stringify(res.data)
              self.$router.push({ path: '/index' })
            }
          })
          // self.$store.dispatch('getPermissionBtns').then(() => {
          // })
        }).catch(function (res) {
          if (res.response.data.errorCode === 0) {
            self.isShow = true
            self.tishi = '帐号或者密码错误'
//            self.account = ''
            self.password = ''
            self.getCode()
          } else if (res.response.data.errorCode === '0003') {
            self.isShow = true
            self.tishi = '用户不存在'
            self.account = ''
            self.password = ''
            self.getCode()
          } else if (res.response.data.errorCode === '10020') {
            self.isShow = true
            self.tishi = '用户已被停用,请联系管理员'
            self.account = ''
            self.password = ''
            self.getCode()
          } else {
            self.checkCode = ''
            self.isShow = true
            // self.tishi = '验证码错误'
            self.tishi = res.response.data.errorMessage
            self.getCode()
          }
          // $('.errowShow').text(JSON.parse(req.responseText).errorCode === '0' ? '邮箱或密码错误' : '验证码错误').fadeIn()
          // getCode()
        })
      },
      cityAdress () {
        let _this = this
        return apis.request(cloudApi.addressList, {}).then(function (res) {
          let data = res.data
          if (data.length > 0) {
            if (data[0].children.length === 0 && data.length === 1) {
              window.localStorage.addressData = data[0].tenantCode
              window.localStorage.addressDataValue = data[0].tenantName
              _this.isOnly = true
              _this.address = localStorage.addressDataValue
              return 'true'
            }
            _this.list1 = []
            for (var i = 0; i < data.length; i++) {
              _this.list1.push(data[i])
            }
          } else {
            _this.list1 = []
          }
        })
      },
      nextTown (item) {
        var _this = this
        _this.one = false
        _this.two = true
        _this.value1 = item.cityName
        console.log(item.children)
        let data = item.children
        if (data.length > 0) {
          _this.list2 = []
          data.forEach((item) => {
            _this.list2.push(item)
          })
        } else {
          _this.list2 = []
        }
      },
      nextTown1 (item) {
        let _this = this
        _this.one = false
        _this.two = false
        _this.three = true
        _this.value2 = item.districtName
        console.log(item.children)
        let data = item.children
        if (data.length > 0) {
          _this.list3 = []
          data.forEach((item) => {
            _this.list3.push(item)
          })
        } else {
          _this.list3 = []
        }
      },
      modal () {
        this.cityAdress()
        this.sheetVisible = true
        this.isShow = false
        this.one = true
        this.two = false
        this.three = false
      },
      cancel () {
        this.sheetVisible = false
      },
      modal1 () {
        if (this.isOnly) {
          return
        }
        this.cityAdress().then((data) => {
          if (!data) {
            this.sheetVisible = true
            this.isShow = false
            this.one = true
            this.two = false
            this.three = false
          }
        })
      },
      stringfy (val) {
        return JSON.stringify(val)
      },
      checked (item, index) {
        if (item.ischecked === undefined && item.isColor === undefined) {
          if (checking) {
            checking.ischecked = false
            checking.isColor = false
          }
          this.$set(item, 'ischecked', true)
          this.$set(item, 'isColor', true)
          checking = item
          return
        }

        if (item.ischecked) {
          item.ischecked = false
          item.isColor = false
          checking = null
        } else {
          if (checking) {
            checking.ischecked = false
            checking.isColor = false
          }
          item.ischecked = true
          item.isColor = true
          checking = item
        }
      },
      sure () {
        if (this.list1.length > 0) {
          this.list1.forEach((item) => {
            if (item.ischecked) {
              this.address = item.tenantName
              this.tenant = item.tenantCode
              window.localStorage.addressData = this.tenant
              window.localStorage.addressDataValue = this.address
              this.sheetVisible = false
            }
          })
        }
        if (this.list2.length > 0) {
          this.list2.forEach((item) => {
            if (item.ischecked) {
              this.address = item.tenantName
              this.tenant = item.tenantCode
              window.localStorage.addressData = this.tenant
              window.localStorage.addressDataValue = this.address
              this.sheetVisible = false
            }
          })
        }
        if (this.list3.length > 0) {
          this.list3.forEach((item) => {
            if (item.ischecked) {
              this.address = item.tenantName
              this.tenant = item.tenantCode
              window.localStorage.addressData = this.tenant
              window.localStorage.addressDataValue = this.address
              this.sheetVisible = false
            }
          })
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  @import "../../assets/css/variable";

  .wrap_login {
    padding-top: 1.28rem;
    height: 100%;
  }

  .mint-header {
    font-size: .36rem;
    color: #fff;
    font-weight: bolder;
    height: 1.28rem;
    /*line-height: 1rem;*/
    /*padding: .2rem 0;*/
  }

  .mint-header-title {
    font-weight: 500 !important;
  }

  .errowShow {
    width: 100%;
    position: absolute;
    top: 1.28rem;
    bottom: 0;
    left: 0;
    right: 0;
    height: .7rem;
    background: $white;
    font-size: .3rem;
    color: $theme-color;
    text-align: center;
    line-height: .5rem;
    padding: .1rem 0;
    box-shadow: $box-shadow-base;
  }

  .wrap_login {
    margin: 0 auto;
    position: relative;
  }

  .form-group {
    background-color: #ffffff;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    height: .88rem;
    line-height: .88rem;
    box-sizing: border-box;
    overflow: hidden;
    /*padding: 0.05rem;*/
    padding: 0 .3rem;
  }

  .inputForm {
    display: inline-block;
    font-size: .36rem;
    border: 0;
    border-radius: 0;
    position: absolute;
    top: .19rem;
    outline: 0;
    color: #1D1F22;
  }

  .login_label {
    color: #000000;
    font-size: .36rem;
    width: 1.54rem;
    text-align: left;
    display: inline-block;
  }

  .account {
    width: 100%;
    /*padding-left: .28rem;*/
  }

  .password {
    /*width: 100%;*/
    /*padding-left: .28rem;*/
  }

  #imgcontainer {
    width: 1.1rem;
    height: .8rem;
    line-height: .5rem;
    outline: none;
    display: inline-block;
    float: right;
    margin-right: .6rem;
    margin-top: .1rem;
  }

  .checkCode {
    width: 49%;
    /*padding-left: .28rem;*/
  }

  .btn {
    margin: .4rem 0;
    height: .94rem;
    line-height: .94rem;
    font-size: .36rem;
    border-radius: .14rem;
  }

  .link {
    font-size: .28rem;
    color: #333333;
    margin-top: .2rem;
    padding: 0 .64rem;
    overflow: hidden;
  }

  a, a:hover, a:focus {
    color: #333333;
    text-decoration: none;
  }

  .fr {
    float: right;
  }

  .fl {
    float: left;
  }

  .mint-button--primary {
    background-color: #E4393C;
  }

  .model {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    right: 0;
    /*height: 3.5rem;*/
    background: #FFFFFF;
    z-index: 20000;
    .addressList {
      overflow: auto;
      max-height: 4rem;
      li {
        font-size: .36rem;
        color: #1D1F22;
        line-height: 1rem;
        text-align: center;
        border-bottom: 1px solid #e5e5e5;
      }
    }
  }

  .v-model {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .5;
    background: #000;
    bottom: 3.5rem;
  }

  .pullUp {
    transform: translate3d(0px, 3.5rem, 0px) !important;
  }

  .modelTop {
    height: .4rem;
    font-size: .3rem;
    color: #E4393C;
    div {
      padding: .2rem .2rem;
    }
  }

  .ulList {
    margin-top: .5rem;
    ul {
      width: 100%;
    }
  }

  .check {
    width: 0.24rem;
    height: 0.24rem;
    border: 1px solid #979797;
    display: inline-block;
    border-radius: 50%;
    /*margin-bottom: 0.12rem;*/
    margin-left: 0.25rem;
    float: left;
    margin-top: .4rem;
  }

  .checked {
    background: url('../../assets/images/success_big.png') center no-repeat;
    background-size: 0.24rem 0.24rem;
    border: none;
  }

  .nochecked {
    border: 1px solid #979797;
  }

  .fontColor {
    color: #E4393C;
  }

  .nofontColor {
    color: inherit;
  }

  .togglePsd {
    color: #707172;
    position: absolute;
    right: 0.32rem;
    font-size: 0.6rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue